/* eslint-disable react-hooks/exhaustive-deps */
import Breadcrumcomponent from 'components/BreadCrumbMex/BreadCrumb';
import SimpleContainer from 'components/InputsMex/containers/SimpleContainer';
import { DropDownFilter } from 'components/InputsMex/inputs';
import Page from 'components/Page';
import ProgressSpinner from 'components/PogressSpinners/ProgressSpinner';
import useCustomToast from 'hooks/useCustomToasts';
import React, { useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import { Col, Row } from 'reactstrap';
import useParametrosPago from 'redux/hooks/useParametrosPago';
import { PASOS_BREADCRUMBS } from 'utils/constants';
import Loading from 'wrappers/Loading';
import BreadCurmbPasos from '../BreadCrumbMex/BreadCrumbTipo2';
import ModalbtaEmpresa from '../ModalMex/ModalbtaEmpresa';
import ComponenteValoresTotales from '../ValoresTotalesMex/ComponenteValoresTotales';
import FormDias from './FormDias';

const ResumenLayout = ({
  LoadingInfCliente,
  loading,
  ObjDatosTarifacion,
  dataTarifacion,
  mostrarActualizar,
  onEliminarPlan,
  valMaximo,
  valMinimo,
  onActualizarValoresTarifa,
  onActualizarCotizacion,
  onClickPagar,
  setState,
}) => {
  const methods = useForm({ mode: 'onChange' });

  const [recalculando, setRecalculando] = useState(false);

  const [showOpciones, setshowOpciones] = useState(false);

  const { addWarningToast } = useCustomToast();

  const [puedeEmitir, setPuedeEmitir] = useState(true);

  const { setCombos, parametros, ...stateParametrosPago } = useParametrosPago();

  const onChangeFormPago = async (value) => {
    if (value.onChange === 'recalcular') {
      setRecalculando(true);
      const dataFormaPago = {
        idPlazo: value.id,
        formaPago: value.tipo,
        labelPlazo: value.label,
      };
      setState({
        dataPago: dataFormaPago,
      });
      await onActualizarCotizacion(ObjDatosTarifacion.planes, false);
      //setShowLogos(false);
    } else {
      //setShowLogos(true);
    }

    setshowOpciones(value?.mostrarSubopciones);
    setRecalculando(false);
  };

  useEffect(() => {
    if (stateParametrosPago.error) {
      addWarningToast(stateParametrosPago.error.message, { autoDismiss: false });
    }
  }, [stateParametrosPago.error]);

  useEffect(() => {
    try {
      const datosTarifacion = ObjDatosTarifacion.valorTotal[0];
      setCombos({
        formaPago: datosTarifacion.formaPago,
        idPlazo: datosTarifacion.idPlazo,
        setshowOpciones,
        reset: methods.reset,
      });
      setState({
        dataPago: {
          idPlazo: datosTarifacion?.idPlazo,
          formaPago: datosTarifacion?.formaPago,
          labelPlazo: datosTarifacion?.labelPlazo,
        },
      });
    } catch (error) {}
  }, []);

  useEffect(() => {
    if (ObjDatosTarifacion?.valorTotal) {
      validarPuedeEmitir();
    }
  }, [ObjDatosTarifacion]);

  const validarPuedeEmitir = () => {
    const datosTarifacion = ObjDatosTarifacion.valorTotal[0];
    setPuedeEmitir(datosTarifacion.permitirEmitir);
    if (!datosTarifacion.permitirEmitir) {
      return addWarningToast(datosTarifacion.msgError, { autoDismiss: false });
    }
  };

  const onChangePlazo = async (value) => {
    setRecalculando(true);
    const formaPago = methods.getValues('formaPago');

    const dataFormaPago = {
      idPlazo: value.ID,
      formaPago: formaPago.tipo,
      labelPlazo: value.Name,
    };
    setState({
      dataPago: dataFormaPago,
    });
    await onActualizarCotizacion(ObjDatosTarifacion.planes, false);
    setRecalculando(false);
  };

  return (
    <Loading loading={loading || LoadingInfCliente} message="Cargando...">
      <Page>
        <Breadcrumcomponent {...PASOS_BREADCRUMBS.TRAVELBTA.breadCrumb} />

        <BreadCurmbPasos {...PASOS_BREADCRUMBS.TRAVELBTA.breadCrumbPasos[4]} />

        <Row>
          <div className="col-md-6">
            <div className="container-plan-btaemp">
              <div className="plan-title-resumen">Planes seleccionados</div>

              {ObjDatosTarifacion?.planes
                ?.map((e) => {
                  e.total = 0;
                  if (e.valorTotal) {
                    const total = e.valorTotal.find((e) => e.banderaMoneda);
                    e.total = `${total.monedaSimbolo}${total.primaNeta}`;
                  }
                  return e;
                })
                ?.map((plan, j) => {
                  const callback = (dias, posicion) => {
                    ObjDatosTarifacion.planes[posicion] = {
                      ...ObjDatosTarifacion.planes[posicion],
                      diasNumero: dias,
                    };
                    setState({
                      ObjDatosTarifacion,
                      mostrarActualizar: true,
                    });
                  };

                  const callbackError = (dias, posicion) => {
                    ObjDatosTarifacion.planes[posicion] = {
                      ...ObjDatosTarifacion.planes[posicion],
                      diasNumero: dias,
                    };
                    setState({
                      ObjDatosTarifacion,
                      mostrarActualizar: false,
                    });
                  };

                  if (plan.bandSeleccion) {
                    return (
                      <div className="container-plan-option" key={j}>
                        <Row>
                          <Col xs={10}>
                            <div
                              className="title-plan-option"
                              style={{ fontSize: '20px' }}
                            >
                              {plan?.planNombre}
                            </div>
                          </Col>
                          <Col xs={2}>
                            <ModalbtaEmpresa
                              plan={plan}
                              total={plan.total}
                              posicion={j}
                              onEliminarPlan={onEliminarPlan}
                            />
                          </Col>
                        </Row>

                        <FormDias
                          plan={plan}
                          total={plan.total}
                          valMaximo={valMaximo}
                          valMinimo={valMinimo}
                          callback={callback}
                          ObjDatosTarifacion={ObjDatosTarifacion}
                          posicion={j}
                          callbackError={callbackError}
                        />
                      </div>
                    );
                  }
                })}

              <div className="agregar-mas-planes-cont">
                <Link
                  to={`/travel-empresas-planes?id=${dataTarifacion.cotCodigo}`}
                  className={'agregar-mas-planes'}
                >
                  Agregar más planes
                </Link>
              </div>

              <FormProvider {...methods}>
                <div className="row mx-4">
                  <div className="col-xl-6 ">
                    <SimpleContainer
                      name="formaPago"
                      label="Opción de pago"
                      helpText={
                        stateParametrosPago.loading && 'Cargando formas de pago...'
                      }
                    >
                      <DropDownFilter
                        name="formaPago"
                        filter={false}
                        rules={{ required: 'Obligatorio' }}
                        options={parametros?.formasPago}
                        onChangeFn={onChangeFormPago}
                        loading={stateParametrosPago.loading}
                        loadingText={stateParametrosPago?.loading && 'Cargando...'}
                      />
                    </SimpleContainer>
                  </div>

                  {showOpciones && (
                    <div className="col-xl-6">
                      <SimpleContainer label="Elije cuántos meses" name="idPlazo">
                        <DropDownFilter
                          name="idPlazo"
                          filter={false}
                          rules={{ required: 'Obligatorio' }}
                          options={parametros?.plazos}
                          onChangeFn={onChangePlazo}
                          loading={stateParametrosPago?.loading}
                        />
                      </SimpleContainer>
                    </div>
                  )}
                </div>
              </FormProvider>
            </div>
          </div>

          <div className="col-md-6 h-100">
            {ObjDatosTarifacion?.valorTotal && (
              <div className="card-login-mex h-100">
                <div className=" mx-5 mb-5">
                  {recalculando && <ProgressSpinner label="Recalculando..." />}

                  {!recalculando && (
                    <ComponenteValoresTotales
                      totales={ObjDatosTarifacion.valorTotal}
                      mostrarActualizar={mostrarActualizar}
                      onActualizarValoresTarifa={onActualizarValoresTarifa}
                      onClickPagar={onClickPagar}
                      puedeEmitir={puedeEmitir}
                    />
                  )}
                </div>
              </div>
            )}
          </div>
        </Row>
      </Page>
    </Loading>
  );
};

export default ResumenLayout;
